import React, { useEffect, useState } from "react";
import projectData from "./ProjectData";
import Spinner from "react-bootstrap/Spinner";
import "./Project.css";

const Playlist = () => {
  const [spin, setSpin] = useState(true);

  useEffect(() => {
    setTimeout(() => {
      setSpin(false);
    }, 1000);
  }, []);

  return (
    <>
      {spin ? (
        <div
          className="d-flex justify-content-center align-items-center"
          style={{ minHeight: "90vh", position: "relative", zIndex: 10 }}
        >
          <div className="text-center d-flex">
            <Spinner animation="border" variant="danger" />
            <p className="mt-1 text-white">&nbsp;Loading...</p>
          </div>
        </div>
      ) : (
        <div className="playlist-container">
          <h2 className="playlist-heading">Projects</h2>
          <div className="card_div">
            <div className="row d-flex justify-content-center align-items-stretch g-4" style={{ margin: 0 }}>
              {projectData.map((elem, index) => {
                return (
                  <div className="col-12 col-md-6 col-lg-4 d-flex justify-content-center mb-4" key={index}>
                    <div className="project-card animate-project-card" style={{ width: "100%" }}>
                      <div className="project-img-container">
                        <img
                          className="project-img"
                          src={elem.imgsrc}
                          alt={elem.projectName}
                        />
                      </div>
                      <div className="d-flex flex-column justify-content-between" style={{ padding: '1rem' }}>
                        <h3 className="project-title">
                          {elem.projectName}
                        </h3>
                        <div className="d-flex justify-content-center mt-3">
                          <a
                            href={elem.demo}
                            target="_blank"
                            rel="noopener noreferrer"
                            style={{ textDecoration: 'none' }}
                          >
                            <button className="project-btn">
                              View Project
                            </button>
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default Playlist;
